module.exports = __webpack_public_path__ + "static/media/tick.c247e1cc.svg";